import { useCallback, useState } from 'react';

interface ReferenceElementReturn<T = HTMLElement | null> {
  referenceElement: T;
  setReferenceElement: (element: T) => void;
  clearReferenceElement: () => void;
}

/**
 * Hook that manages a reference element with setter and clear functions
 * @returns Object containing reference element state and handlers
 */
export const useReferenceElement = <T = HTMLElement | null>(): ReferenceElementReturn<T> => {
  const [referenceElement, setReferenceElement] = useState<T>(null as T);

  const clearReferenceElement = useCallback((): void => {
    setReferenceElement(null as T);
  }, []);

  return {
    referenceElement,
    setReferenceElement,
    clearReferenceElement,
  };
};
